var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXeuBlueCheckStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 2.45126L8.98666 23.5L0 12.6978L2.21614 10.2699L8.57199 16.5664L21.3412 0.5L24 2.45126Z",
    fill: "#02235B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXeuBlueCheckStroke);
export default __webpack_public_path__ + "static/media/xeu-blue-check-stroke.563ae0cd9f10b6a6428799b209b78fac.svg";
export { ForwardRef as ReactComponent };